// extracted by mini-css-extract-plugin
export var carrierIcon = "_xy-0";
export var carrierLogo = "_xy-1";
export var detailsSection = "_xy-2";